import { Link } from "react-router-dom";
import { WhatsappLogo, EnvelopeSimple, Globe, MapPin } from "@phosphor-icons/react";

export default function Footer() {
    return (
        <footer className="bg-[#0A192F] text-white border-t border-white/5" data-testid="site-footer">
            <div className="max-w-7xl mx-auto px-6 md:px-8 py-16 grid md:grid-cols-4 gap-10">
                <div className="md:col-span-2 max-w-md">
                    <div className="flex items-center gap-3 mb-4">
                        <img src="/logo.png" alt="CashFlow Ads" className="w-14 h-14 rounded-full object-cover bg-white shadow-lg ring-2 ring-[#D4AF37]/40" />
                        <div>
                            <div className="font-display font-bold text-lg">CashFlow Ads</div>
                            <div className="text-[10px] uppercase tracking-[0.2em] text-[#D4AF37]">
                                Where Reach Becomes Revenue
                            </div>
                        </div>
                    </div>
                    <p className="text-white/65 text-sm leading-relaxed mb-5">
                        North America's leading WhatsApp Status advertising network. We place your ad in front of real
                        humans through a vetted poster network.
                    </p>
                    <div className="space-y-2 text-sm">
                        <a href="https://wa.me/18457295009" className="flex items-center gap-2 text-white/80 hover:text-[#25D366] transition-colors" data-testid="footer-whatsapp-link">
                            <WhatsappLogo size={18} weight="fill" /> 845-729-5009
                        </a>
                        <a href="mailto:cashflowads613@gmail.com" className="flex items-center gap-2 text-white/80 hover:text-[#D4AF37] transition-colors" data-testid="footer-email-link">
                            <EnvelopeSimple size={18} /> cashflowads613@gmail.com
                        </a>
                        <div className="flex items-center gap-2 text-white/60">
                            <Globe size={18} /> cashflow-ads.com
                        </div>
                    </div>
                </div>

                <div>
                    <div className="text-xs uppercase tracking-[0.2em] text-[#D4AF37] mb-4">Company</div>
                    <ul className="space-y-2.5 text-sm text-white/75">
                        <li><Link to="/" className="hover:text-white">Home</Link></li>
                        <li><Link to="/packages" className="hover:text-white">Packages</Link></li>
                        <li><Link to="/become-poster" className="hover:text-white">Become a Poster</Link></li>
                        <li><Link to="/schedule" className="hover:text-white">Schedule Campaign</Link></li>
                        <li><Link to="/contact" className="hover:text-white">Contact</Link></li>
                    </ul>
                </div>

                <div>
                    <div className="text-xs uppercase tracking-[0.2em] text-[#D4AF37] mb-4">Coverage</div>
                    <ul className="space-y-2.5 text-sm text-white/75">
                        <li className="flex items-center gap-2"><MapPin size={14} /> United States</li>
                        <li className="flex items-center gap-2"><MapPin size={14} /> Canada</li>
                        <li className="flex items-center gap-2"><MapPin size={14} /> United Kingdom</li>
                        <li className="flex items-center gap-2"><MapPin size={14} /> Israel</li>
                    </ul>
                </div>
            </div>

            <div className="border-t border-white/5">
                <div className="max-w-7xl mx-auto px-6 md:px-8 py-5 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-white/50">
                    <div>© {new Date().getFullYear()} CashFlow Ads. All rights reserved.</div>
                    <div className="italic font-display tracking-wide text-[#D4AF37]/80">"Where Reach Becomes Revenue."</div>
                </div>
            </div>
        </footer>
    );
}
